module.exports = __webpack_public_path__ + "img/featuredartist (6).e3b841cd.jpg";